module.exports = __webpack_public_path__ + "img/pdf.d179747e.png";